import { PrismicText, PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import { AnimatedSection } from 'remote-com-shared/style/motion';
import styled from 'styled-components';
import SwiperCore, { Autoplay, Scrollbar, Pagination, Navigation } from 'swiper/core';
import { SwiperSlide, Swiper } from 'swiper/react';

import Circle from './assets/3d-circle.png';

import {
  SectionWrapper,
  LabelComponent,
  TitleComponent,
  DescriptionComponent,
  CircleLeftWrapper,
  CircleLeft,
  LogosWrapper,
  LogoEntry as LogoEntryComponent,
} from './index';

import { CardsList } from '@/src/views/RemoteRelocation/WorkAnywhere';

SwiperCore.use([Autoplay, Scrollbar, Pagination, Navigation]);

export const CountryCardsSwiper = styled(Swiper)`
  position: relative;
  padding-top: 70px;
  padding-bottom: 70px;

  .swiper-slide {
    width: auto;
  }

  // to remove the pause at the end of each slide
  .swiper-wrapper {
    -webkit-transition-timing-function: linear !important;
    -o-transition-timing-function: linear !important;
    transition-timing-function: linear !important;
    align-items: center;
  }
`;

export const Logos = styled(LogosWrapper)`
  max-width: unset;
`;

export const LogoEntry = styled(LogoEntryComponent)`
  position: relative;
  margin-right: 30px;
  margin-left: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RightBG = styled.div`
  --sideGradient: linear-gradient(
    270deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0.0104167) 69.46%,
    rgba(244, 244, 244, 0) 69.47%,
    rgba(255, 255, 255, 0) 69.47%
  );
  position: absolute;
  background: var(--sideGradient);
  width: 20%;
  z-index: 2;
  height: 100%;
  bottom: 0;
  right: 0;
`;

export const LeftBG = styled(RightBG)`
  position: absolute;
  baseline-shift: baseline;
  background: var(--sideGradient);
  width: 20%;
  z-index: 2;
  height: 100%;
  bottom: 0;
  left: 0;
  transform: rotate(-180deg);
`;

const ComingSoonWrapper = styled.div`
  position: absolute;
  bottom: -50px;
  width: 84px;
  padding: 5px 22px;
  background: var(--colors-turquoise);
  ${({ theme }) => theme.typography.subHeadSM}
  text-transform: uppercase;
  border-radius: 17px;
  text-align: center;
  margin-top: 20px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const ClientLogosSlider = ({
  title,
  logos,
  customTitle,
  customDescription,
  description,
  circleBottomLeft,
  tone,
  label,
  $titleWidth,
  $textColor,
  backgroundImage,
  bossa,
  swiperProps = {},
}) => (
  <SectionWrapper $bossa={bossa} $tone={tone} $background={backgroundImage?.src}>
    {tone !== 'purpleMinsk' && !backgroundImage && (
      <>
        <LeftBG />
        <RightBG />
      </>
    )}
    {label && <LabelComponent $textColor={$textColor}>{label}</LabelComponent>}
    {customTitle ? (
      <TitleComponent $titleWidth={$titleWidth} $textColor={$textColor}>
        <h1>{customTitle}</h1>
      </TitleComponent>
    ) : (
      <TitleComponent $titleWidth={$titleWidth}>
        <PrismicRichText field={title} />
      </TitleComponent>
    )}

    {customDescription && (
      <DescriptionComponent $textColor={$textColor}>{customDescription}</DescriptionComponent>
    )}
    {description && (
      <DescriptionComponent $textColor={$textColor}>
        <PrismicText field={description} />
      </DescriptionComponent>
    )}
    <Logos>
      <AnimatedSection
        ComponentName={CountryCardsSwiper}
        centeredSlides
        loop
        autoplay={{
          delay: 1,
        }}
        speed={5000}
        slidesPerView="auto"
        freeMode
        {...swiperProps}
      >
        <CardsList>
          {logos.map(({ logo_image: logo, coming_soon: comingSoon }, index) => {
            const { dimensions: sourceDimensions } = logo;
            const isSvg = /\.svg$/i.test(logo.url);

            // Cut non-svg dimensions in half if 2x resolution
            let dimensions = sourceDimensions;
            const reference2xWidth = 200;
            if (!isSvg && dimensions.width > reference2xWidth) {
              dimensions = {
                width: dimensions.width / 2,
                height: dimensions.height / 2,
                unoptimized: true,
              };
            }

            return (
              <SwiperSlide key={index}>
                <div>
                  <LogoEntry>
                    {comingSoon && <ComingSoonWrapper>Coming soon</ComingSoonWrapper>}
                    <Image src={logo.url} alt={logo.alt ?? ''} {...dimensions} quality="100" />
                  </LogoEntry>
                </div>
              </SwiperSlide>
            );
          })}
        </CardsList>
      </AnimatedSection>
    </Logos>
    {circleBottomLeft && (
      <CircleLeftWrapper>
        <CircleLeft src={Circle} alt="" />
      </CircleLeftWrapper>
    )}
  </SectionWrapper>
);
